import React, { Component } from 'react';
import styled from 'styled-components';
import sectionBorderRadius from './sectionBorderRadius';
import Image from './Image';
import { TitleText, SubTitleText } from './Title';

const ThumbnailView = styled.div`
  display: flex;
  ${({ zeroFlexShrink }) => zeroFlexShrink && 'flex-shrink: 0;'} 
  color: ${props => props.theme.botCardMessageTextColor};
  background-color: ${props => props.theme.botCardMessageBackgroundColor};
  ${sectionBorderRadius};
  ${({ flexGrow }) => flexGrow && 'flex-grow: 1'};
`;

const CardContainer = styled.div`
  display: flex;
  overflow: hidden;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

const TitlesContainer = styled.div`
  padding: 0px;
  min-width: 0px;
  flex: 1 1 75%;
  box-sizing: border-box;
  line-height: 19px;
  padding: 12px 18px;
`;

const ImageContainer = styled.div`
  padding: 0px;
  min-width: 0px;
  flex: 1 1 25%;
  box-sizing: border-box;
  margin: 12px 18px;
`;

const Padding = styled.div`
  height: 8px;
  flex: 1;
`;

class Thumbnail extends Component {
  render() {
    const {
      title,
      subtitle,
      imageSrc,
      isStart,
      isEnd,
      flexGrow = false,
      zeroFlexShrink = false
    } = this.props;

    return (
      <ThumbnailView
        isStart={isStart}
        isEnd={isEnd}
        flexGrow={flexGrow}
        zeroFlexShrink={zeroFlexShrink}
      >
        <CardContainer>
          <TitlesContainer>
            {title && <TitleText>{title}</TitleText>}
            {subtitle && <SubTitleText>{subtitle}</SubTitleText>}
          </TitlesContainer>
          {imageSrc && (
            <ImageContainer>
              <Image key={'image'} type={'image'} src={imageSrc} />
            </ImageContainer>
          )}
        </CardContainer>
        <Padding />
      </ThumbnailView>
    );
  }
}

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Thumbnail.js